var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon awesome-location-arrow",
    d: "M8.88365 0.239267L1.2664 3.75495C0.38757 4.16514 0.680513 5.45416 1.61797 5.45416H4.8407V8.6769C4.8407 9.61435 6.12973 9.90748 6.53992 9.02847L10.0556 1.41122C10.3485 0.707902 9.58678 -0.0538589 8.88365 0.239267Z",
    fill: "#B79D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.6340449a0cf524917c1bf4a1f9184cfd.svg";
export { ForwardRef as ReactComponent };